import type { IntlShape } from "@formatjs/intl";
import { Skeleton } from "antd";
import type { HookAPI } from "antd/es/modal/useModal";
import { connect, type DispatchProp } from "react-redux";
import type { State as RouterState } from "router5";
import ConnectedAppLayout from "../../AppLayout";
import type { RootState } from "../../store";
import type {
	PaginatedturbineComponentResultsSideloadList,
	TurbineRetrieve,
} from "../../generated-axios-client";
import { TurbineViewRender } from "./TurbineViewRender";

export type TurbineViewProps = {
	intl: IntlShape<string>;
	currentRoute: RouterState | null;
	turbine: TurbineRetrieve | null;
	components: PaginatedturbineComponentResultsSideloadList;
	modalApi: HookAPI | undefined;
};

type TurbineViewPageProps = TurbineViewProps & DispatchProp;

const TurbineView = (props: TurbineViewPageProps) => {
	const { intl, currentRoute, modalApi, turbine, components, dispatch } = props;

	if (!components || !turbine) {
		return <Skeleton active />;
	}
	const turbineData = {
		turbine,
		components,
	};

	return (
		<ConnectedAppLayout>
			<TurbineViewRender
				intl={intl}
				currentRoute={currentRoute}
				turbineData={turbineData}
				modalApi={modalApi}
				dispatch={dispatch}
			/>
		</ConnectedAppLayout>
	);
};

const withTurbineView = (state: RootState) => ({
	turbine: state.turbine.turbine,
	components: state.component.list,
	currentRoute: state.router.route,
	intl: state.intl.datetimeIntl,
	modalApi: state.appFeedback.modal,
});
export const ConnectedTurbineViewPage = connect(withTurbineView)(TurbineView);

export default ConnectedTurbineViewPage;
